import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import type { IneligibilityReason } from './resolve-cross-join-third-party-nudges.ts';

export type EVENT_TYPE = 'sendTrackEvent' | 'sendOperationalEvent';

type FireExperimentAnalytics = (
	type: EVENT_TYPE,
	actionSubject: string,
	action: string,
	actionSubjectId?: string,
	attributes?: Record<string, any>,
) => unknown;

export const getExperimentAnalytics =
	(
		createAnalyticsEvent: CreateUIAnalyticsEvent,
		{
			attributes: commonAttributes = {},
		}: {
			attributes?: {} | undefined;
		} = {},
	): FireExperimentAnalytics =>
	(type, actionSubject, action, actionSubjectId, attributes) =>
		createAnalyticsEvent({
			type,
			data: {
				action,
				actionSubject,
				actionSubjectId,
				source: 'confluenceCrossJoin3PNudges',
				attributes: {
					...commonAttributes,
					...attributes,
				},
			},
		}).fire();

export const fireEligibilityChecked = (
	analytics: FireExperimentAnalytics,
	ineligibilityReason: IneligibilityReason | 'ELIGIBLE',
): void => {
	const flagKey = 'confluenceCrossJoin3PNudges';
	const action = 'tracked';
	analytics('sendTrackEvent', 'eligibility', action, undefined, {
		flagKey,
		ineligibilityReason,
	});
};

export const fireExperimentError = (analytics: FireExperimentAnalytics, error: Error): unknown =>
	analytics('sendOperationalEvent', 'showCrossJoin3PNudges', 'failed', undefined, {
		message: String(error),
		details: { ...error },
	});
